module.exports = __webpack_public_path__ + "img/3.1e9d4c44.svg";